import {
  withExport,
  withResourceState,
} from '@kinet-open-network/client/shared/data-access/state';
import { signalStore } from '@ngrx/signals';
import { FeesService } from '../services/fees.service';

export const FeesStore = signalStore(
  { protectedState: false }, withResourceState(FeesService),
  withExport(FeesService),
);
